document.addEventListener("DOMContentLoaded", function () {
  function updateFreeShippingBar() {
    const bar = document.querySelector("#free-shipping-bar");
    if (!bar) return;

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const threshold = parseInt(bar.dataset.threshold, 10);
        const span = bar.querySelector(".text-subdued");
        const total = cart.total_price;

        if (!span) return;

        if (total >= threshold) {
          span.textContent = bar.dataset.reachedMessage;
        } else {
          const remaining = ((threshold - total) / 100).toFixed(2);
          span.textContent = bar.dataset.unreachedMessage.replace("__amount__", `$${remaining}`);
        }
      });
  }

  // Run once on page load
  updateFreeShippingBar();

  // Re-run after every cart drawer update (Shopify replaces DOM)
  // const drawer = document.querySelector("cart-drawer, .cart-drawer");
  // if (drawer) {
  //   const observer = new MutationObserver(() => {
  //     updateFreeShippingBar();
  //   });
  //   observer.observe(drawer, { childList: true, subtree: true });
  // }

  const recurpay_observer = new MutationObserver(function (mutations, obs) {
      let widget = document.querySelector(".recurpay__widget");
      if (widget) {
        document.querySelectorAll('.recurpay_purchase_data').forEach(function(el) {
          el.remove();
        });
        obs.disconnect();
      }
  });
  recurpay_observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});




